import { APP_ROLE } from '@/config/env'
import { useRestaurantStore } from '@/entities/restaurant/model/useRestaurantStore'
import { useAdminCatalogMetaStore } from '@/features/admin/model/useAdminCatalogMetaStore'
import { useAdminModifiersStore } from '@/features/admin-catalog/model/useAdminModifiersStore'
import { useAdminOrdersStore } from '@/features/admin-orders/model/useAdminOrdersStore'
import { useAdminRestaurantsStore } from '@/features/admin-restaurants/model/useAdminRestaurantsStore'
import { useAdminSystemWalletsStore } from '@/features/admin-wallets/model/useAdminSystemWalletsStore'
import { useClientOrdersStore } from '@/features/client-orders/model/useClientOrdersStore'
import { useNotificationChannelsStore } from '@/features/client-notification-channels/model/useNotificationChannelsStore'
import { useCourierStore } from '@/entities/courier/model/useCourierStore'
import { useCourierOrdersStore } from '@/features/courier-orders/model/useCourierOrdersStore'
import { useFinanceStore } from '@/features/finance/model/useFinanceStore'
import { useRestaurantCatalogStore } from '@/features/restaurant-catalog/model/useRestaurantCatalogStore'
import { useRestaurantOrdersStore } from '@/features/restaurant-orders/model/useRestaurantOrdersStore'

export function clearAppSessionState() {
  if (APP_ROLE === 'restaurant') {
    useRestaurantStore().clear()
    useRestaurantOrdersStore().clear()
    useRestaurantCatalogStore().clear()
    useFinanceStore().clear()
    return
  }

  if (APP_ROLE === 'courier') {
    useCourierStore().clear()
    useCourierOrdersStore().clear()
    useFinanceStore().clear()
    return
  }

  if (APP_ROLE === 'admin') {
    useAdminOrdersStore().clear()
    useAdminRestaurantsStore().clear()
    useAdminCatalogMetaStore().clear()
    useAdminModifiersStore().clear()
    useAdminSystemWalletsStore().clear()
    return
  }

  if (APP_ROLE === 'client') {
    useClientOrdersStore().clear()
    useNotificationChannelsStore().clear()
  }
}
